<div class="container-fluid">
  <app-content-tab-list activeTab="0" type="marketplace" category="Marketplace"></app-content-tab-list>

  <div class="row section1 justify-content-between mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Books ({{books.length}})</h5>
        <p class="home-subtitle">Manage marketplace books from here</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <button class="btn btn-primary btn-dashboard" (click)="openCreateModal()">
        <i class="las la-book"></i>Add Book
      </button>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="books-filters-card">
        <div class="books-filters-title">Filter Books</div>
        <div class="books-filters-grid">
          <div class="books-filter-item books-filter-item-wide">
            <label class="books-filter-label">Keyword</label>
            <input type="text"
              class="form-control"
              [(ngModel)]="filters.keyword"
              (keydown)="handleFilterInputKeyDown($event)"
              placeholder="Book name, author, email, description"/>
          </div>
          <div class="books-filter-item">
            <label class="books-filter-label">Status</label>
            <select class="form-control" [(ngModel)]="filters.status">
              <option value="all">All</option>
              @for (option of statusOptions; track option) {
                <option [value]="option.value">{{option.label}}</option>
              }
            </select>
          </div>
          <div class="books-filter-item">
            <label class="books-filter-label">Category</label>
            <select class="form-control" [(ngModel)]="filters.category">
              <option value="all">All</option>
              @for (option of categoryOptions; track option) {
                <option [value]="option.value">{{option.label}}</option>
              }
            </select>
          </div>
          <div class="books-filter-actions">
            <button class="btn books-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
            @if (hasActiveFilters()) {
              <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Cover</th>
              <th scope="col">Book</th>
              <th scope="col">Author</th>
              <th scope="col">Category</th>
              <th scope="col">Status</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!loading && filteredBooks.length) {
            <tbody>
              @for (book of filteredBooks | paginate: { itemsPerPage: perPage, currentPage: page, totalItems: filteredBooks.length, id:'marketplace-books'}; track book) {
                <tr class="client"
                  >
                  <td class="text-nowrap" [attr.title]="(book.id || '').toUpperCase()"><span>{{(book.id || '').slice(-6).toUpperCase()}}</span>
                  <i (click)="handleCopyToClipboard(book.id);" class="las la-copy la-lg pointer copy-icon"></i>
                </td>
                <td>
                  <img [src]="book.coverImageUrl || 'assets/images/placeholder.png'"
                    class="book-cover-thumb"
                    onerror="this.src='assets/images/placeholder.png'"
                    alt="">
                </td>
                <td>
                  <div class="book-title">{{book.name || 'NA'}}</div>
                  <div class="book-subtitle">{{book.tagline || 'No tagline'}}</div>
                </td>
                <td>
                  <div>{{book.author?.name || 'NA'}}</div>
                  <small class="text-muted email-display">{{book.author?.email | lowercaseEmail}}</small>
                </td>
                <td class="text-capitalize">{{book.category || 'other'}}</td>
                <td>
                  <span class="book-status" [ngClass]="'status-' + (book.status || 'published')">
                    {{book.status || 'published'}}
                  </span>
                </td>
                <td>{{book.createdAt | date:'medium'}}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect btn-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="mr-3 text-primary py-2 text-nowrap">
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        <a class="dropdown-item text-info border-bottom py-2 text-nowrap" (click)="openEditModal(book)">
                          <i class="las la-edit mb-1 la-lg align-middle mr-0"></i> Edit</a>
                          <a
                            class="dropdown-item text-danger py-2 text-nowrap"
                            (click)="deleteBook(book)">
                            <i class="las la-trash-alt mb-1 la-lg align-middle mr-0"></i> Delete</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
                @if (loading) {
                  <tbody>
                    @for (q of loaders; track q) {
                      <tr>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'160px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'64px', width:'44px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'180px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'160px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'140px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
            @if (!loading && !filteredBooks.length) {
              <div class="d-flex align-items-center justify-content-center py-5">
                No books found
              </div>
            }
            <div class="float-right mt-3">
              <pagination-controls (pageChange)="pageChange($event)" id="marketplace-books"></pagination-controls>
            </div>
          </div>
        </div>
      </div>

      @if (showBookModal) {
        <div class="modal fade show marketplace-book-modal" tabindex="-1" role="dialog" [ngStyle]="{'display': 'block'}" (click)="closeBookModal()">
          <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
            <div class="modal-content marketplace-book-modal-content">
              <div class="modal-header marketplace-book-modal-header">
                <div>
                  <h5 class="modal-title marketplace-book-modal-title">{{isEditMode ? 'Edit Book' : 'Add Book'}}</h5>
                </div>
                <button type="button" class="close marketplace-book-close-btn" aria-label="Close" (click)="closeBookModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body marketplace-book-modal-body">
                <div class="book-form-grid">
                  <div class="book-cover-field">
                    <label class="book-label">Cover Page <span>*</span></label>
                    <div class="book-cover-upload" (click)="handleCoverUploadClick()">
                      @if (bookForm.coverImageUrl && !uploadingCover) {
                        <img [src]="bookForm.coverImageUrl" alt="">
                      }
                      @if (!bookForm.coverImageUrl && !uploadingCover) {
                        <img src="assets/images/placeholder.png" alt="">
                      }
                      @if (uploadingCover) {
                        <div class="book-cover-loader">
                          <img src="assets/images/loading.gif" width="42" alt="">
                        </div>
                      }
                      <button type="button" class="btn btn-sm btn-outline-primary mt-2" [disabled]="uploadingCover">
                        {{bookForm.coverImageUrl ? 'Change Cover' : 'Upload Cover'}}
                      </button>
                    </div>
                    <input id="book_cover_upload"
                      type="file"
                      accept=".png, .jpg, .jpeg, .webp"
                      class="form-control d-none"
                      (change)="uploadCover($event)">
                  </div>
                  <div class="book-form-fields">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <label class="book-label">Book Name <span>*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="bookForm.name" placeholder="Enter book name">
                      </div>
                      <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                        <label class="book-label">Status</label>
                        <select class="form-control" [(ngModel)]="bookForm.status">
                          @for (option of statusOptions; track option) {
                            <option [value]="option.value">{{option.label}}</option>
                          }
                        </select>
                      </div>
                    <div class="col-12 col-lg-7 mt-3">
                      <label class="book-label">Book Author <span>*</span></label>
                      <div class="author-search-wrap">
                        <input type="text"
                          class="form-control"
                          [ngModel]="bookForm.authorName"
                          (ngModelChange)="onAuthorInput($event)"
                          (focus)="onAuthorInputFocus()"
                          (blur)="onAuthorInputBlur()"
                          placeholder="Type author name (existing users will appear)">
                        @if (authorSearchLoading) {
                          <div class="author-search-loading">Searching users...</div>
                        }
                        @if (authorSuggestionsVisible && lookupUsers.length) {
                          <div class="author-suggestions">
                            @for (user of lookupUsers; track user.id) {
                              <button type="button"
                                class="author-suggestion-item"
                                (mousedown)="selectAuthorSuggestion(user)">
                                <span>{{user.firstName}} {{user.lastName}}</span>
                                @if (user.email) {
                                  <small class="email-display">{{user.email | lowercaseEmail}}</small>
                                }
                              </button>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-lg-5 mt-3">
                      <label class="book-label">Category</label>
                      <select class="form-control" [(ngModel)]="bookForm.category">
                        @for (option of categoryOptions; track option) {
                          <option [value]="option.value">{{option.label}}</option>
                        }
                      </select>
                    </div>
                    <div class="col-12 mt-3">
                      <label class="book-label">Short Tagline</label>
                      <input type="text" class="form-control" [(ngModel)]="bookForm.tagline" placeholder="One-line hook for the book">
                    </div>
                    <div class="col-12 mt-3">
                      <label class="book-label">Book Description <span>*</span></label>
                      <textarea class="form-control book-description-input"
                        [(ngModel)]="bookForm.description"
                      placeholder="Enter book description"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="book-optional-stack">
                <details class="book-optional-panel">
                  <summary>
                    <span>Buy Links</span>
                    <i class="las la-angle-down"></i>
                  </summary>
                  <div class="book-optional-panel-body">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <label class="book-label">Amazon Link</label>
                        <input type="url" class="form-control" [(ngModel)]="bookForm.amazonUrl" placeholder="https://amazon...">
                      </div>
                      <div class="col-12 col-md-6 mt-3 mt-md-0">
                        <label class="book-label">Flipkart Link</label>
                        <input type="url" class="form-control" [(ngModel)]="bookForm.flipkartUrl" placeholder="https://flipkart...">
                      </div>
                    </div>
                    <div class="book-other-links mt-3">
                      <label class="book-label">Other Buy Links</label>
                      @for (link of bookForm.otherLinks; track link; let i = $index) {
                        <div class="book-other-link-row">
                          <input type="text"
                            class="form-control"
                            [(ngModel)]="link.name"
                            [name]="'otherLinkName' + i"
                            placeholder="Store name">
                          <input type="url"
                            class="form-control"
                            [(ngModel)]="link.url"
                            [name]="'otherLinkUrl' + i"
                            placeholder="https://...">
                            @if (i === bookForm.otherLinks.length - 1) {
                              <button type="button" class="book-row-btn" (click)="addOtherLink()">+</button>
                            }
                            <button type="button" class="book-row-btn danger" (click)="removeOtherLink(i)">&times;</button>
                          </div>
                        }
                      </div>
                    </div>
                  </details>
                  <details class="book-optional-panel">
                    <summary>
                      <span>Podcast Association</span>
                      <i class="las la-angle-down"></i>
                    </summary>
                    <div class="book-optional-panel-body">
                      <div class="row">
                        <div class="col-12 col-md-4">
                          <label class="book-label">Podcast Association</label>
                          <select class="form-control"
                            [(ngModel)]="bookForm.podcastAssociationMode"
                            (change)="onPodcastAssociationModeChange()">
                            <option value="author" [disabled]="!bookForm.authorUserId">Show author's podcasts</option>
                            <option value="manual">Choose podcasts</option>
                            <option value="none">No podcasts</option>
                          </select>
                        </div>
                        @if (bookForm.podcastAssociationMode === 'author') {
                          <div class="col-12 col-md-8 mt-3 mt-md-0">
                            <label class="book-label">Author Podcasts</label>
                            @if (authorPodcastsLoading) {
                              <div class="author-podcast-loading">Loading podcasts...</div>
                            } @else if (!authorPodcastOptions.length) {
                              <div class="author-podcast-empty">No podcasts found for this author.</div>
                            } @else {
                              <div class="author-podcast-grid">
                                @for (podcast of authorPodcastOptions; track podcast.id) {
                                  <div class="author-podcast-card"
                                    [class.selected]="isAuthorPodcastSelected(podcast.id)">
                                    <input type="checkbox"
                                      class="author-podcast-checkbox"
                                      [checked]="isAuthorPodcastSelected(podcast.id)"
                                      (change)="toggleAuthorPodcastSelection(podcast.id, $any($event.target).checked)">
                                    <a class="author-podcast-preview"
                                      [class.disabled]="!podcast.mediaUrl"
                                      href="#"
                                      title="Open media in new tab"
                                      (click)="openPodcastPreview(podcast.mediaUrl, $event)">
                                      @if (podcast.thumbnail) {
                                        <img [src]="podcast.thumbnail"
                                          alt="Podcast preview"
                                          class="author-podcast-preview-img">
                                      } @else if (podcast.mediaType === 'Video' && podcast.mediaUrl) {
                                        <video class="author-podcast-preview-video"
                                          [src]="podcast.mediaUrl"
                                          muted
                                          playsinline
                                          preload="metadata"></video>
                                      } @else {
                                        <div class="author-podcast-preview-fallback">No Preview</div>
                                      }
                                    </a>
                                    <div class="author-podcast-card-content">
                                      <div class="author-podcast-card-title">{{podcast.title}}</div>
                                      <div class="author-podcast-card-meta">
                                        <span class="author-podcast-option-type">{{podcast.mediaType}}</span>
                                        @if (podcast.createdAt) {
                                          <span>{{podcast.createdAt}}</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                              <small class="text-muted">All are selected by default. Uncheck any podcast you do not want to show.</small>
                            }
                          </div>
                        }
                        @if (bookForm.podcastAssociationMode === 'manual') {
                          <div class="col-12 col-md-8 mt-3 mt-md-0">
                            <label class="book-label">Choose Podcasts</label>
                            @if (manualPodcastsLoading) {
                              <div class="author-podcast-loading">Loading podcasts...</div>
                            } @else if (!manualPodcastOptions.length) {
                              <div class="author-podcast-empty">No podcasts available.</div>
                            } @else {
                              <div class="author-podcast-grid">
                                @for (podcast of manualPodcastOptions; track podcast.id) {
                                  <div class="author-podcast-card"
                                    [class.selected]="isManualPodcastSelected(podcast.id)">
                                    <input type="checkbox"
                                      class="author-podcast-checkbox"
                                      [checked]="isManualPodcastSelected(podcast.id)"
                                      (change)="toggleManualPodcastSelection(podcast.id, $any($event.target).checked)">
                                    <a class="author-podcast-preview"
                                      [class.disabled]="!podcast.mediaUrl"
                                      href="#"
                                      title="Open media in new tab"
                                      (click)="openPodcastPreview(podcast.mediaUrl, $event)">
                                      @if (podcast.thumbnail) {
                                        <img [src]="podcast.thumbnail"
                                          alt="Podcast preview"
                                          class="author-podcast-preview-img">
                                      } @else if (podcast.mediaType === 'Video' && podcast.mediaUrl) {
                                        <video class="author-podcast-preview-video"
                                          [src]="podcast.mediaUrl"
                                          muted
                                          playsinline
                                          preload="metadata"></video>
                                      } @else {
                                        <div class="author-podcast-preview-fallback">No Preview</div>
                                      }
                                    </a>
                                    <div class="author-podcast-card-content">
                                      <div class="author-podcast-card-title">{{podcast.title}}</div>
                                      <div class="author-podcast-card-meta">
                                        <span class="author-podcast-option-type">{{podcast.mediaType}}</span>
                                        @if (podcast.createdAt) {
                                          <span>{{podcast.createdAt}}</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                              <small class="text-muted">Select the podcasts you want to associate with this book.</small>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </details>
                </div>
              </div>
              <div class="modal-footer marketplace-book-modal-footer">
                <button type="button" class="btn btn-outline-secondary" [disabled]="saving || uploadingCover" (click)="closeBookModal()">Cancel</button>
                <button type="button" class="btn btn-primary btn-dashboard ml-0" [disabled]="saving || uploadingCover" (click)="saveBook()">
                  {{saving ? 'Saving...' : (isEditMode ? 'Update Book' : 'Add Book')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      @if (showBookModal) {
        <div class="modal-backdrop fade show"></div>
      }
      @if (showCoverCropModal) {
        <div class="modal fade show marketplace-book-crop-modal"
          tabindex="-1"
          role="dialog"
          [ngStyle]="{'display': 'block'}"
          (click)="closeCoverCropModal()">
          <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
            <div class="modal-content marketplace-book-crop-modal-content">
              <div class="modal-header marketplace-book-crop-modal-header">
                <h5 class="modal-title marketplace-book-crop-modal-title">Crop Cover Image</h5>
                <button type="button"
                  class="close marketplace-book-close-btn"
                  aria-label="Close"
                  [disabled]="uploadingCover"
                  (click)="closeCoverCropModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body marketplace-book-crop-modal-body">
                <image-cropper
                  [imageFile]="coverImageFile"
                  [maintainAspectRatio]="true"
                  [aspectRatio]="coverAspectRatio"
                  format="png"
                  [imageQuality]="100"
                  [resizeToWidth]="900"
                  (imageCropped)="onCoverImageCropped($event)"
                  (loadImageFailed)="onCoverImageLoadFailed()"></image-cropper>
              </div>
              <div class="modal-footer marketplace-book-crop-modal-footer">
                <button type="button"
                  class="btn btn-outline-secondary"
                  [disabled]="uploadingCover"
                  (click)="closeCoverCropModal()">Cancel</button>
                <button type="button"
                  class="btn btn-primary btn-dashboard ml-0"
                  [disabled]="uploadingCover || !croppedCoverFile"
                  (click)="uploadCroppedCover()">
                  {{uploadingCover ? 'Uploading...' : 'Crop & Upload'}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show crop-modal-backdrop"></div>
      }
